import CityPage from "../CityPage";

export default function PalosHills() {
  return <CityPage slug="palos-hills" />;
}
